function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var icons = {};

function warn(msg, vm) {
  if (!vm) {
    /* eslint-disable no-console */
    console.error(msg);
    /* eslint-enable no-console */

    return;
  }

  vm.constructor["super"].util.warn(msg, vm);
}

export default {
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          warn("Invalid prop: prop \"name\" is referring to an unregistered icon \"".concat(val, "\".\n") + "Please make sure you have imported this icon before using it.", this);
          return false;
        }

        return true;
      }
    },
    title: String,
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical' || val === 'both';
      }
    },
    label: String,
    tabindex: [Number, String]
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },
  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);

      if (isNaN(scale) || scale <= 0) {
        warn("Invalid prop: prop \"scale\" should be a number over 0.", this);
        return this.outerScale;
      }

      return scale * this.outerScale;
    },
    klass: function klass() {
      var _this = this;

      var classes = {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-flip-both': this.flip === 'both',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };

      if (this.classes) {
        Object.keys(this.classes).forEach(function (c) {
          if (_this.classes[c]) {
            classes[c] = true;
          }
        });
      }

      return classes;
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }

      return null;
    },
    box: function box() {
      if (this.icon) {
        return "0 0 ".concat(this.icon.width, " ").concat(this.icon.height);
      }

      return "0 0 ".concat(this.width, " ").concat(this.height);
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }

      var _this$icon = this.icon,
          width = _this$icon.width,
          height = _this$icon.height;
      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }

      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }

      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId('vat-');
        ids[id] = uniqueId;
        return " id=\"".concat(uniqueId, "\"");
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;

        if (!id || !ids[id]) {
          return match;
        }

        return "#".concat(ids[id]);
      });
      return raw;
    },
    focusable: function focusable() {
      var tabindex = this.tabindex;

      if (tabindex == null) {
        return 'false';
      }

      var index = typeof tabindex === 'string' ? parseInt(tabindex, 10) : tabindex;

      if (index >= 0) {
        return null;
      }

      return 'false';
    }
  },
  mounted: function mounted() {
    this.updateStack();
  },
  updated: function updated() {
    this.updateStack();
  },
  methods: {
    updateStack: function updateStack() {
      var _this2 = this;

      if (!this.name && this.name !== null && this.$children.length === 0) {
        warn("Invalid prop: prop \"name\" is required.", this);
        return;
      }

      if (this.icon) {
        return;
      }

      var width = 0;
      var height = 0;
      this.$children.forEach(function (child) {
        child.outerScale = _this2.normalizedScale;
        width = Math.max(width, child.width);
        height = Math.max(height, child.height);
      });
      this.childrenWidth = width;
      this.childrenHeight = height;
      this.$children.forEach(function (child) {
        child.x = (width - child.width) / 2;
        child.y = (height - child.height) / 2;
      });
    }
  },
  render: function render(h) {
    if (this.name === null) {
      return h();
    }

    var options = {
      "class": this.klass,
      style: this.style,
      attrs: {
        role: this.$attrs.role || (this.label || this.title ? 'img' : null),
        'aria-label': this.label || null,
        'aria-hidden': !(this.label || this.title),
        tabindex: this.tabindex,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        viewBox: this.box,
        focusable: this.focusable
      },
      on: this.$listeners
    };

    if (this.raw) {
      var html = "<g>".concat(this.raw, "</g>");

      if (this.title) {
        html = "<title>".concat(escapeHTML(this.title), "</title>").concat(html);
      }

      options.domProps = {
        innerHTML: html
      };
    }

    var content = this.title ? [h('title', this.title)] : [];
    return h('svg', options, this.raw ? null : content.concat([h('g', this.$slots["default"] || (this.icon ? [].concat(_toConsumableArray(this.icon.paths.map(function (path, i) {
      return h('path', {
        attrs: path,
        key: "path-".concat(i)
      });
    })), _toConsumableArray(this.icon.polygons.map(function (polygon, i) {
      return h('polygon', {
        attrs: polygon,
        key: "polygon-".concat(i)
      });
    }))) : []))]));
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];
      var _icon$paths = icon.paths,
          paths = _icon$paths === void 0 ? [] : _icon$paths,
          d = icon.d,
          _icon$polygons = icon.polygons,
          polygons = _icon$polygons === void 0 ? [] : _icon$polygons,
          points = icon.points;

      if (d) {
        paths.push({
          d: d
        });
      }

      if (points) {
        polygons.push({
          points: points
        });
      }

      icons[name] = assign({}, icon, {
        paths: paths,
        polygons: polygons
      });
    }
  },
  icons: icons
};

function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

function assign(obj) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    for (var key in source) {
      if (hasOwn(source, key)) {
        obj[key] = source[key];
      }
    }
  });
  return obj;
}

var count = 0;

function getId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return prefix + count++;
}

var ESCAPE_MAP = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '&': '&amp;'
};

function escapeHTML(html) {
  return html.replace(/[<>"&]/g, function (c) {
    return ESCAPE_MAP[c] || c;
  });
}